import { useState, useEffect } from "react";
import axios from "axios";
import { useLanguage } from "../contexts/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const usePageContent = (pageId) => {
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/content/${pageId}`);
        setContent(response.data.content?.[language] || {});
      } catch (err) {
        setContent({});
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [pageId, language]);

  return { content, loading };
};
